import { useFormContext } from "react-hook-form";
import { NFDocumentFooter } from "../../../Shared/NewForms/NFDocuments/NFDocumentFooter";

export const CashRegisterReceiptsDetailFooter = () => {
  const { watch } = useFormContext();
  const watchTotalAmount = watch("totalAmount");

  return (
    <>
      <NFDocumentFooter>
        <div className={"d-flex"}>
          <span className={"me-2"}>Total:</span>{" "}
          <b>{watchTotalAmount ? watchTotalAmount.toFixed(2) : "-"}</b>
        </div>
      </NFDocumentFooter>
    </>
  );
};
